import script from "./QuickView.vue?vue&type=script&setup=true&lang=js"
export * from "./QuickView.vue?vue&type=script&setup=true&lang=js"

import "./QuickView.vue?vue&type=style&index=0&id=54b18801&lang=scss"

const __exports__ = script;

export default __exports__